/**
 * Index script file
 *
 * @package    App
 * @author     Vadym Karpenko <vkarpenko@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider, connect } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { IntlProvider } from 'react-intl';
import ReactGA from 'react-ga';

import './modernizr';

import configureStore, { history } from './configureStore';
import Layout from 'Layouts/Layout';

const store = configureStore();

let ConnectedIntlProvider = connect(state => {
    const { locale, messages } = state.translation;
    return {
        locale: locale,
        key: locale,
        messages,
    };
})(IntlProvider);

ReactGA.initialize('UA-131224743-1');
history.listen(location => {
    ReactGA.pageview(location.pathname + location.search);
    console.log(location.pathname);
});

const render = Component => {
    ReactDOM.render(
        <Provider store={store}>
            <ConnectedIntlProvider>
                <ConnectedRouter history={history}>
                    <Component />
                </ConnectedRouter>
            </ConnectedIntlProvider>
        </Provider>,
        document.getElementById('root')
    );
};

render(Layout);

if (module.hot) {  // eslint-disable-line
    module.hot.accept('Layouts/Layout', () => { // eslint-disable-line
        render(Layout);
    });
}



// WEBPACK FOOTER //
// ./src/index.js